import {
  type ClipboardConfigCreationContext,
  EdgelessClipboardConfig,
} from '@blocksuite/affine-block-surface';
import { type BlockSnapshot, fromJSON } from '@blocksuite/store';

import { remapearPassos } from './tuninho/passos';

export class EdgelessClipboardFrameConfig extends EdgelessClipboardConfig {
  static override readonly key = 'affine:frame';

  override createBlock(
    frame: BlockSnapshot,
    context: ClipboardConfigCreationContext
  ): string | null {
    if (!this.surface) return null;

    const { oldToNewIdMap, newPresentationIndexes } = context;
    const { xywh, title, background, childElementIds, presentationSteps } =
      frame.props;

    const newChildElementIds: Record<string, boolean> = {};

    if (typeof childElementIds === 'object' && childElementIds !== null) {
      Object.keys(childElementIds).forEach(oldId => {
        const newId = oldToNewIdMap.get(oldId);
        if (newId) {
          newChildElementIds[newId] = true;
        }
      });
    }

    /*
     * Os passos de apresentação viajam com o frame (card 1849823264159827694).
     *
     * ⚠️ **Sem esta linha, copiar um frame marcado perde a marcação em SILÊNCIO.** Não é
     * distração do upstream: a desestruturação acima é uma **lista fechada**, e prop que não
     * esteja nela simplesmente não existe no bloco novo. Nada falha, nada avisa.
     *
     * O cenário é o mais provável de todos, porque é o gesto de quem usa a funcionalidade a
     * sério: monta o frame, marca os elementos, e duplica (⌘D) para fazer a variação
     * seguinte. Quem testa com um frame só nunca vê.
     *
     * O remapeamento usa o MESMO `oldToNewIdMap` que o `childElementIds` logo acima — tem de
     * ser o mesmo, senão o passo apontaria para o elemento do frame de origem.
     */
    const newPresentationSteps = remapearPassos(presentationSteps, oldToNewIdMap);

    const frameId = this.crud.addBlock(
      'affine:frame',
      {
        xywh,
        background,
        title: fromJSON(title),
        childElementIds: newChildElementIds,
        presentationIndex: newPresentationIndexes.get(frame.id),
        presentationSteps: newPresentationSteps,
      },
      this.surface.model.id
    );
    return frameId;
  }
}
